import { projectDocumentationSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import z from 'zod';

import { queryKeys } from './queryKeys';

type Response = z.infer<typeof responseSchema>;
const responseSchema = z.object({
  hasInsideRoofSensors: z.boolean(),
  projectDocumentation: projectDocumentationSchema.nullable(),
});

interface Params {
  projectId: string;
  noRetry?: boolean;
}

export function useProjectDocumentation({ projectId, noRetry = false }: Params) {
  const url = `/projects/${projectId}/documentation`;

  const { data, error, isLoading } = useQuery<Response>({
    queryKey: queryKeys.getProjectDocumentation(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId,
    retry: !noRetry,
  });

  return {
    hasInsideRoofSensors: data?.hasInsideRoofSensors || false,
    projectDocumentation: data?.projectDocumentation || null,
    error,
    isLoading,
  };
}
